import {Stack, Typography} from '@mui/material';
import {memo, useCallback, useEffect, useMemo, useState} from 'react';
import {getAccountInfo, getAllRates, getPaymentUrl} from '../http/paymentAPI';
import {observer} from 'mobx-react-lite';
import {Tariffs} from '../components/Tariffs';

const PaymentPage = observer(() => {
    const [paymentList, setPaymentList] = useState([]);
    const [paymentRateId, setPaymentRateId] = useState(null);
    const [patientCount, setPatientCount] = useState(null);
    const [paymentDate, setPaymentDate] = useState(null);
    const [balance, setBalance] = useState(null);
    const [paySumm, setPaySumm] = useState('');
    const [error, setError] = useState(null);
    const [isLoading, setLoading] = useState(true);

    // Функция для получения данных о тарифах и аккаунте
    const fetchData = async () => {
        setLoading(true);
        try {
            const [rates, accountInfo] = await Promise.all([getAllRates(), getAccountInfo()]);

            setPaymentList(rates.reverse());
            if (accountInfo) {
                setPaymentDate(
                    accountInfo.paymentDate
                        ? new Date(Date.parse(accountInfo.paymentDate)).toLocaleDateString()
                        : '-'
                );
                setPaymentRateId(accountInfo.paymentRateId);
                setBalance(accountInfo.balance);
                setPatientCount(accountInfo.patientCount);
            }
        } catch (err) {
            console.error(err);
            setError('Ошибка при загрузке счета');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const currentTariff = useMemo(
        () => paymentList.find((el) => el.id === paymentRateId),
        [paymentList, paymentRateId]
    );

    const handlePaySummChange = useCallback((e) => {
        setPaySumm(e.target.value);
    }, []);

    const handlePayment = useCallback(() => {
        if (!paySumm || paySumm <= 0) {
            alert('Некорректная сумма пополнения');
            return;
        }

        const Receipt = {
            items: [
                {
                    name: 'Оплата за использование продукта TolaMed',
                    quantity: 1,
                    sum: paySumm,
                    tax: 'none'
                }
            ]
        };

        getPaymentUrl(paySumm, Receipt)
            .then((data) => {
                if (!data.url) {
                    alert('Ошибка сервера при генерации ссылки на оплату');
                    return;
                }
                // Создаем ссылку и открываем в новой вкладке
                const link = document.createElement('a');
                link.href = data.url;
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch((error) => {
                alert('Ошибка сервера при генерации ссылки на оплату');
            });
    }, [paySumm]);
    // Отображение ошибок или загрузки
    if (error) {
        return (
            <Stack>
                <Typography variant='h5'>Счет и оплата</Typography>
                <Typography variant='h6' color='error'>
                    {error}
                </Typography>
            </Stack>
        );
    }

    if (isLoading) {
        return (
            <Stack>
                <Typography variant='h5'>Счет и оплата</Typography>
                <Typography variant='h6'>Загрузка...</Typography>
            </Stack>
        );
    }

    return (
        <Tariffs
            currentTariff={currentTariff}
            patientCount={patientCount}
            paymentDate={paymentDate}
            paymentList={paymentList}
            paySumm={paySumm}
            balance={balance}
            handlePaySummChange={handlePaySummChange}
            handlePayment={handlePayment}
        />
    );
});

export default memo(PaymentPage);
